export default function TemplateCardSkeleton() {
  return (
    <div className="bg-white border border-gray-100 rounded-xl overflow-hidden animate-pulse">
      {/* Image area */}
      <div className="aspect-video bg-gray-200" />

      {/* Content */}
      <div className="p-5">
        <div className="h-5 rounded-lg bg-gray-200 mb-2" style={{ width: '68%' }} />
        <div className="space-y-2 mb-4">
          <div className="h-3.5 rounded bg-gray-100 w-full" />
          <div className="h-3.5 rounded bg-gray-100" style={{ width: '82%' }} />
        </div>
        <div className="flex items-center justify-between">
          <div className="flex gap-1.5">
            <div className="h-5 w-14 rounded-full bg-gray-100" />
            <div className="h-5 w-16 rounded-full bg-gray-100" />
          </div>
          <div className="h-8 w-28 rounded-lg bg-gray-200" />
        </div>
      </div>
    </div>
  );
}

export function TemplateGridSkeleton({ count = 9 }: { count?: number }) {
  return (
    <>
      {Array.from({ length: count }).map((_, i) => (
        <TemplateCardSkeleton key={i} />
      ))}
    </>
  );
}
